export default "__VITE_ASSET__C_2CDNNO__"